import { User } from "@models";

export class BaseModel {
    id: number;
    createdAt: string;
    createdById?: number;
    IsDeleted?: number;
    user?: User
}